export default __webpack_public_path__ + "static/media/Soulmark Belt.d3b03376.jpg";